/**
 * 登录模块的接口
 * */
import base from './base' // 接口域名列表
import axios from 'axios' // 导入创建的axios实例
import qs from 'qs' // 序列化post请求的
import constant from '../utils/constant'

let www = base.proxy

axios.defaults.headers.common['token'] = constant.getToken()

// 开始定义接口
const login = {
  encryptMd5Api (params) {
    return axios.post(`${www}/wtapi/encryptMd5`, qs.stringify(params))
  },
  loginApi (params) {
    return axios.post(`${www}/wtapi/login`, qs.stringify(params))
  }
}

export default login



// WEBPACK FOOTER //
// ./src/api/login.js